import React from 'react'
import { Divider as KittenDivider } from '@ui-kitten/components'

export default function Divider({ color, marginVertical = 15, marginTop, width = '99%', style }) {
  return (
    <KittenDivider
      style={[
        {
          marginVertical,
          marginTop,
          width,
          alignSelf: 'center',
          ...(color ? { backgroundColor: color } : {}),
        },
        style,
      ]}
    />
  )
}
